import React from "react";
import { Outlet } from "@tanstack/react-router";

export const SelectGameLayout: React.FC = () => {
  return <Outlet />;
};
